const generateId = () => {
  return Math.floor(Math.random() * Date.now());
};

export default generateId;
